import { request } from "../../apis";

export const apiGetMyProjectList = (params) => request("get", `/userfacility/lists`, params, true);

export const apiGetMyProjectDetail = (params) => request("get", `/usercharge/list`, params, true);
